module.exports = __webpack_public_path__ + "img/blog.accaee69.jpg";